module.exports = __webpack_public_path__ + "static/img/my.3eedb12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/my.png
// module id = 1n/l
// module chunks = 18